import React from 'react';
import Layout from '../../components/layout/layout';
import { WebPageSchema, BreadcrumbSchema } from '../../lib/utils/schema-utils';

export default function MappingRHPage() {
  return (
    <Layout
      title="Mapping RH - Test de compatibilité | recruteurs.io"
      description="Évaluez la compatibilité entre vos candidats et vos équipes grâce à notre outil de Mapping RH."
    >
      <WebPageSchema
        page={{
          title: "Mapping RH - Test de compatibilité",
          description: "Évaluez la compatibilité entre vos candidats et vos équipes.",
          url: "https://recruteurs.io/ressources/mapping-rh"
        }}
      />
      
      <BreadcrumbSchema
        items={[
          { name: "Accueil", url: "https://recruteurs.io" },
          { name: "Ressources", url: "https://recruteurs.io/ressources" },
          { name: "Mapping RH", url: "https://recruteurs.io/ressources/mapping-rh" }
        ]}
      />

      <div className="py-20">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-[#d03484] to-[#d47254]">
              Test de compatibilité RH
            </h1>
            <p className="text-xl text-neutral-600">
              Évaluez l'adéquation entre vos candidats et votre culture d'entreprise grâce à notre outil de mapping RH.
            </p>
          </div>

          <div id="hr-compatibility-test" className="w-full max-w-4xl mx-auto p-4">
            <iframe
              src="https://soft-platypus-aaf096.netlify.app/"
              width="100%"
              height="1200"
              frameBorder="0"
              style={{ border: 'none', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)' }}
              title="Test de compatibilité RH"
              loading="lazy"
              allow="clipboard-write"
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}